import React, { useState, useEffect, useRef } from 'react'
import { Bar } from 'react-chartjs-2'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import styled from 'styled-components'
import moment from 'moment'
import 'moment/locale/ko'

// utils
import { getTicks } from '../../utils/getTicks'

// styles
import colors from '../../styles/colors'

const TEMP_DATA = [
  {
    label: '주간주문수',
    borderWidth: 2,
    data: null,
    fill: false,
    pointHoverRadius: 2,
    pointHoverBorderWidth: 4,
    borderColor: colors.mainG,
    backgroundColor: colors.mainG,
    barThickness: 10,
  },
]

const INIT_DATA = ['월', '화', '수', '목', '금', '토', '일']

const OrderChart = ({ chartItem, isMobile, overChartIdx, isDarkMode }) => {
  // test
  const chartRef = useRef(null)
  const [data, setData] = useState({
    labels: INIT_DATA,
    datasets: TEMP_DATA,
    // 플러그인
    plugins: [ChartDataLabels],
  })
  const [options, setOptions] = useState(null)

  // 툴팁 그림자
  const shadowPlugin = {
    id: 'shadow',
    beforeDraw: (chart) => {
      const { ctx } = chart
      const _fill = ctx.fill

      ctx.fill = function () {
        ctx.save()
        ctx.shadowColor = 'rgba(0, 0, 0, 0.1)'
        ctx.shadowBlur = 12
        ctx.shadowOffsetX = 0
        ctx.shadowOffsetY = 3
        _fill.apply(this, arguments)
        ctx.restore()
      }
    },
  }

  useEffect(() => {
    if (chartItem) {
      setData({
        ...data,

        labels: chartItem.date,
        datasets: [
          {
            label: '주간주문수',
            borderWidth: 2,
            data: chartItem.count,
            fill: false,
            pointHoverRadius: 2,
            pointHoverBorderWidth: 4,
            borderColor: colors.mainG,
            backgroundColor: colors.mainG,
            barThickness: isMobile ? 6 : 10,
          },
        ],
      })
    }
  }, [isMobile])

  useEffect(() => {
    if (chartItem) {
      setData({
        ...data,

        labels: chartItem.date,

        datasets: [
          {
            label: '주간주문수',
            borderWidth: 2,
            data: chartItem.count,
            fill: false,
            pointHoverRadius: 2,
            pointHoverBorderWidth: 4,
            borderColor: colors.mainG,
            backgroundColor: colors.mainG,
            barThickness: 10,
          },
        ],
      })

      setOptions({
        responsive: true,

        layout: {
          padding: {
            top: 10,
          },
        },

        elements: {
          point: {
            radius: 0,
          },
        },

        scales: {
          x: {
            grid: {
              display: false,
            },

            ticks: {
              maxTicksLimit: 7,

              font: {
                size: isMobile ? 12 : 14,
              },

              // color: colors.BK,
            },

            offset: true,

            title: {
              display: false,
              text: '날짜',
              font: {
                size: 12,
                weight: 'bold',
              },
            },
            border: {
              display: false,
            },
          },
          y: {
            grid: {
              display: true,
            },

            border: {
              display: false,
            },

            min: 0,
            max: getTicks(Math.max(...chartItem.count)).max,

            ticks: {
              stepSize: getTicks(Math.max(...chartItem.count)).stepSize,
              padding: 15,
              // color: colors.BK,

              font: {
                size: isMobile ? 12 : 14,
              },

              callback: function (value) {
                return isMobile ? value : `${value}건`
              },
            },
            beginAtZero: true,
          },
        },

        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
            position: 'bottom',
          },
          title: {
            display: false,
            text: '날짜별 주문 지표',
          },

          tooltip: {
            backgroundColor: 'white',
            padding: 10,

            xAlign: 'center',
            yAlign: 'center',

            titleColor: 'black',
            bodyColor: colors.mainG,
            caretSize: 0,

            titleMarginBottom: 8,

            titleFont: {
              size: 12,
              weight: 400,
            },
            bodyFont: {
              size: 10,
            },
            bodyAlign: 'left',
            footerFont: {},

            usePointStyle: true,

            callbacks: {
              title: function (item) {
                return `${item[0].label}요일`
              },
              labelColor: function (item) {
                return {
                  borderColor: colors.mainG,
                  backgroundColor: colors.mainG,
                }
              },
              labelPointStyle: function (context) {
                return {
                  pointStyle: 'circle',
                  rotation: 0,
                }
              },
              label: function (item) {
                return ` ${item.formattedValue}건`
              },
            },
          },
        },

        hover: {
          mode: 'index',
          intersect: false,
        },

        interaction: {
          mode: 'index',
          intersect: false,
        },
      })
    }
  }, [chartItem])

  return (
    <Container>
      {data && options && (
        <Bar
          data={data}
          options={options}
          ref={chartRef}
          plugins={[shadowPlugin]}
        />
      )}
    </Container>
  )
}

export default OrderChart

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
`
